import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsOneToMany } from '../../../hooks/use-is-one-to-many';
import { useMultiAddresses } from '../../../hooks/use-multi-addresses';
import { AddressSelectionIndicator } from '../../address-selection-indicator/address-selection-indicator';
import { EnvelopeFormHeaderProps } from '../address-form-types';
import styles from '../address-form.module.scss';
import { CUIText } from '@dotcom/crown-ui';

export const Header = ({ formTitle, isRecipientAddress }: EnvelopeFormHeaderProps) => {
  const { t } = useTranslation();
  const isOneToMany = useIsOneToMany();
  const { shouldUseMultiAddresses } = useMultiAddresses();

  return (
    <>
      <header className={styles.header}>
        <div className={styles['title-container']}>
          <CUIText variant="h5" as="h2" className={styles['title']} data-testid="address-form-title">
            {formTitle}
          </CUIText>
          {shouldUseMultiAddresses && isRecipientAddress && <AddressSelectionIndicator />}
        </div>
        {isOneToMany &&
          (isRecipientAddress ? (
            <CUIText as="span" data-testid="address-form-description" color="textPrimary">
              {t('addressForm.recipientDescription')}
            </CUIText>
          ) : (
            <CUIText as="span" data-testid="address-form-description" color="textPrimary">
              {t('addressForm.senderDescription')}
            </CUIText>
          ))}
      </header>
    </>
  );
};
